<!--
 * @Descripttion: 
 * @version: 2.0.0
 * @Author: ck
 * @Date: 2019-09-24 15:09:58
 * @LastEditors: ck
 * @LastEditTime: 2019-09-24 15:09:58
 -->
<template>
  <div id="app">
    <router-view />
  </div>

</template>

<script>
export default {
  name: "App"
};
</script>


